var map = {
	"./1.png": 46500,
	"./2.png": 52996,
	"./3.png": 32285,
	"./4.png": 77914,
	"./5.png": 49886,
	"./6.png": 20644,
	"./7.png": 35973,
	"./backArrow.png": 76843,
	"./kidsbackground.png": 24895
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62947;